<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <app-admin-card-with-title
      [cardTitle]="t('app.register.to.race.additional.data')" [removeTopMargin]="true">
      <div class="row">
        <div class="col-12 col-xl-6">
          <app-language-input [isInput]="false" [required]="false" [inputForm]="inputForm"
                              [defaultLanguage]="event?.defaultLanguage"
                              [isRichText]="true"
                              [extraLanguages]="event?.extraLanguages" [hrKey]="'shortDescription'"
                              [enKey]="'shortDescriptionEng'"  [bsKey]="'shortDescriptionBs'" [srKey]="'shortDescriptionSr'"
                              [itKey]="'shortDescriptionIta'" [siKey]="'shortDescriptionSlo'"
                              [hrLabel]="'race.details.race.description'"
                              [srLabel]="'race.details.race.description.sr'"
                              [bsLabel]="'race.details.race.description.bs'"
                              [enLabel]="'race.details.race.description.en'"
                              [itLabel]="'race.details.race.description.it'"
                              [siLabel]="'race.details.race.description.slo'"/>
        </div>
        <div class="col-12 col-xl-6">
          <app-language-input [isInput]="false" [required]="false" [inputForm]="inputForm"
                              [defaultLanguage]="event?.defaultLanguage" [isRichText]="true"
                              [extraLanguages]="event?.extraLanguages" [hrKey]="'registrationMessage'"
                              [enKey]="'registrationMessageEng'"
                              [bsKey]="'registrationMessageBs'"
                              [srKey]="'registrationMessageSr'"
                              [itKey]="'registrationMessageIta'" [siKey]="'registrationMessageSlo'"
                              [hrLabel]="'race.details.registration.message'"
                              [srLabel]="'race.details.registration.message.sr'"
                              [bsLabel]="'race.details.registration.message.bs'"
                              [enLabel]="'race.details.registration.message.en'"
                              [itLabel]="'race.details.registration.message.it'"
                              [siLabel]="'race.details.registration.message.slo'"/>
        </div>
      </div>
    </app-admin-card-with-title>
    <app-admin-card-with-title
      [cardTitle]="t('race.details.race.scoring.info')">
      <div class="row">
        <div class="col-12 col-xl-3 pb-3">
          <!-- Scoring definition dropdown -->
          <app-select formControlName="scoringDefinition"
                      [items]="[true, false]" [labels]="['app.common.yes', 'app.common.no']"
                      label="race.details.scoring.definition"/>
        </div>
        <div class="col-12 col-xl-3 pb-3">
          <!-- Scoring for dropdown -->
          <app-select formControlName="scoringFor" [hasDefault]="true"
                      [items]="scoringForTypes" [valueKey]="'id'" [labelKey]="'id'"
                      labelKeyPrefix="race.details.scoring.for.type." label="race.details.scoring.definition.type"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-3 pb-3">
          <!-- Intra points input -->
          <app-input formControlName="itraPoints" label="race.details.itraPoints"/>
        </div>
        <div class="col-12 col-xl-3 pb-3">
          <!-- Mountain level input -->
          <app-input formControlName="mountainLevel" label="race.details.mountainLevel"/>
        </div>
        <div class="col-12 col-xl-3 pb-3">
          <!-- UTMB qualifier input -->
          <app-input formControlName="utmbQualifier" label="race.details.utmbQualifier"/>
        </div>
        <div class="col-12 col-xl-3 pb-3">
          <!-- Finisher level input -->
          <app-input formControlName="finisherLevel" label="race.details.finisherLevel"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-3 pb-3">
          <!-- Name One input -->
          <app-input formControlName="nameOne" label="race.details.nameOne"/>

        </div>
        <div class="col-12 col-xl-3 pb-3">
          <!-- Value One input -->
          <app-input formControlName="valueOne" label="race.details.valueOne"/>
        </div>
      </div>
    </app-admin-card-with-title>
    <app-action-buttons-row (onSave)="onSave()" [disableEditing]="disableEditing"/>
  </form>
</ng-container>
